export class ReviewManagementConfigurationError extends Error {
  constructor(message) {
    super(message);
  }
}